import clsx from "clsx";
import dayjs from "dayjs";
import React, { FC, useState } from "react";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button, DatePicker } from "@pd/pd-ui-kit";
import { add, format, formatISO, startOfMonth } from "date-fns";
import { get } from "lodash";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import Pagination from "~/components/Pagination";
import Table from "~/components/Table";
import { onScrollBottomDealers } from "~/hooks/selectDealerValue";
import { uploadFile } from "~/libs/uploadFile";
import {
  useGetTargetDealerByMonthQuery,
  useImportTargetDealerByMonthMutation,
} from "~/schemas/generated/graphql";
import { useNotify } from "~/shared/hooks/useNotify";
import { handlePopupScroll } from "~/shared/lib/handlePopupScroll";
import { Field } from "~/shared/ui/Field";

import s from "./UploadForm.less";

interface IProps {
  setCloseModal: () => void;
  report: string;
  // refetch;
}

const ImportSRRTargetFileForm: FC<IProps> = ({ setCloseModal, report }) => {
  const { t } = useTranslation();
  const [uploadFileLoader, setUploadFileLoader] = useState(false);
  const { notifySuccess, notifyError } = useNotify();

  const dealersForSelect = onScrollBottomDealers() || [];
  const TARGET_OPTIONS = ["Dealer", "Month", "Target"];

  const schema = yup.object().shape({});

  const { handleSubmit, control, errors, watch } = useForm({
    resolver: yupResolver(schema),
  });

  const watchDealer = watch("dealerIdFilter");
  const watchData = watch("Month");
  const watchFile = watch("file");

  const { data, loading, refetch } = useGetTargetDealerByMonthQuery({
    variables: {
      page: 0,
      count: 25,
      Month: watchData
        ? formatISO(add(startOfMonth(watchData), { days: 1 }))
        : undefined,
      DealerId: watchDealer
        ? watchDealer.value
          ? watchDealer.value
          : undefined
        : undefined,
    },
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
  });

  const targetMonth = get(
    data,
    "SRRGetter.getTargetDealerByMonth.items",
    [],
  ).map((el) => {
    return {
      Dealer: el?.Dealer?.DealerName,
      Month: el?.Month && format(new Date(el?.Month), "dd.MM.yyyy"),
      Target: el?.Target,
    };
  });
  const targetTotal = get(data, "SRRGetter.getTargetDealerByMonth.total", 0);

  const [importTargetDealer, targetDealer] =
    useImportTargetDealerByMonthMutation({
      onCompleted() {
        notifySuccess(t("common.data_uploaded_successfully"));
        refetch();
      },
      onError() {
        setCloseModal();
      },
    });

  const fallBack = () => {
    notifyError(t("common.data_uploaded_error"));
  };

  const onSubmit = () => {
    // Файл грузится при выборе (onUpload поля), здесь остаётся только импорт.
    const fileId = watchFile?.id;
    if (fileId) {
      importTargetDealer({
        variables: {
          fileId: fileId,
        },
      });
    }
  };
  const isDisable = !!watchFile;

  return (
    <>
      <div className={s.wrapperForm}>
        <div className={s.wrapperFilter}>
          <Field
            type="select"
            name="dealerIdFilter"
            label={t(`violationsTable.filterLabelDealership`)}
            control={control}
            options={[...dealersForSelect["dealersForSelect"]]}
            labelInValue
            showSearch
            filterOption={false}
            onSearch={dealersForSelect["searchDealer"]}
            onPopupScroll={(e) =>
              handlePopupScroll(e, dealersForSelect["introspectionHandler"])
            }
            wrapperClassName={s.selectDealer}
          />

          <div className={s.date}>
            <span className={s.dateCustom}>Дата </span>
            <Controller
              name="Month"
              control={control}
              render={({ value, onChange }) => (
                <DatePicker
                  value={value ? dayjs(value) : null}
                  onChange={(d) => onChange(d ? d.toDate() : null)}
                  format="DD.MM.YYYY"
                  disabledDate={(current) =>
                    current && current.isAfter(dayjs(), "day")
                  }
                />
              )}
            />
          </div>
        </div>
        <Pagination total={targetTotal} showRight>
          <Table
            sortable={false}
            items={targetMonth}
            options={TARGET_OPTIONS}
            type={"srrTarget"}
          />
        </Pagination>
      </div>

      <form className={s.upl_form} onSubmit={handleSubmit(onSubmit)}>
        <ul className={s.list}>
          <li>
            <div className={clsx(s.inputWrapper, s.align_label, s.align_error)}>
              <label>{t("srr.uplouad")}</label>
              <Field
                type="file"
                name="file"
                control={control}
                error={errors["file"]?.message}
                accept={["text/csv", "application/vnd.ms-excel"]}
                loading={uploadFileLoader}
                className={s.fileField}
                onUpload={async (file) => {
                  setUploadFileLoader(true);
                  try {
                    const uploaded = await uploadFile(file, fallBack);
                    if (uploaded) {
                      notifySuccess(t("common.file_uploaded_successfully"));
                      return {
                        id: uploaded.id,
                        name: uploaded.name,
                        link: uploaded.link,
                        mimeType: uploaded.mimeType,
                      };
                    }
                  } finally {
                    setUploadFileLoader(false);
                  }
                }}
              />
            </div>
          </li>

          <li
            className={clsx(s.text_drop, {
              // [s.text_drop_file]: !isDisable,
            })}
          />
          <li className={s.with_btn}>
            <Button
              htmlType="submit"
              loading={targetDealer.loading || uploadFileLoader}
              disabled={!isDisable}
            >
              {t("ui.uploadBase")}
            </Button>
          </li>
        </ul>
      </form>
    </>
  );
};
export default ImportSRRTargetFileForm;
